import { useState } from "react";
import { Modal } from "react-bootstrap";
import useTranslator from "../../hooks/useTranslator";
import "./profileDeclaration.css";

type Props = {
  profile: { name: string; is_lead: boolean; is_guarantor?: boolean };
  landlordName: string;
  saving: boolean;
  onAccept: () => void;
  onCancel: () => void;
};

export default function ProfileDeclarationModal({
  profile,
  landlordName,
  saving,
  onAccept,
  onCancel,
}: Props) {
  const { _t } = useTranslator();
  const [checked, setChecked] = useState(false);
  const values = {
    firstName: profile.name.trim().split(/\s+/)[0],
    fullName: profile.name,
    landlord: landlordName,
  };

  return (
    <Modal
      show
      centered
      onHide={saving ? undefined : onCancel}
      backdrop={saving ? "static" : true}
      keyboard={!saving}
      className="profile-declaration-modal"
      aria-labelledby="profile-declaration-title"
      aria-describedby="profile-declaration-description"
    >
      <Modal.Body>
        <div className="profile-declaration-person">
          <span className="profile-declaration-initials" aria-hidden="true">
            {profile.name
              .trim()
              .split(/\s+/)
              .filter(Boolean)
              .map((part) => part[0])
              .filter(
                (_, index, parts) => index === 0 || index === parts.length - 1
              )
              .join("")
              .toLocaleUpperCase()}
          </span>
          <span>
            {profile.is_lead
              ? _t("profileDeclarationYourProfile")
              : `${profile.name} · ${_t(profile.is_guarantor ? "guarantor" : "co_tenant")}`}
          </span>
        </div>
        <h2 id="profile-declaration-title">
          {_t(
            profile.is_lead
              ? "beforeYouStartYourProfile"
              : "profileDeclarationOtherTitle",
            "",
            "translation",
            values
          )}
        </h2>
        <p id="profile-declaration-description">
          {_t(
            profile.is_lead
              ? "profileDeclarationOwnDescription"
              : "profileDeclarationOtherDescription",
            "",
            "translation",
            values
          )}
        </p>
        <label
          className={`profile-declaration-checkbox${checked ? " is-checked" : ""}`}
        >
          <input
            type="checkbox"
            checked={checked}
            disabled={saving}
            onChange={(event) => setChecked(event.target.checked)}
          />
          <span>
            {_t(
              profile.is_lead
                ? "profileDeclarationOwnConsent"
                : "profileDeclarationOtherConsent",
              "",
              "translation",
              values
            )}
          </span>
        </label>
        <div className="profile-declaration-link">
          <a
            href="/pdf/consents/skor_consent.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            {_t("skorConsent")}
          </a>
        </div>
        <div className="profile-declaration-actions" aria-busy={saving}>
          <button type="button" disabled={saving} onClick={onCancel}>
            {_t("cancel")}
          </button>
          <button
            type="button"
            className="profile-declaration-accept"
            disabled={!checked || saving}
            onClick={onAccept}
          >
            {_t(saving ? "saving" : "profileDeclarationAcceptAndContinue")}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
